import { render, staticRenderFns } from "./AddNewStatusModal.vue?vue&type=template&id=bf09232e&scoped=true&"
import script from "./AddNewStatusModal.vue?vue&type=script&lang=js&"
export * from "./AddNewStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewStatusModal.vue?vue&type=style&index=0&id=bf09232e&scoped=true&lang=css&"
import style1 from "./AddNewStatusModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf09232e",
  null
  
)

export default component.exports